import './style/index.scss'

import App from './components/app.tsx'

export default App
